import {BTTrackerBase} from './base';

export class BingTracker extends BTTrackerBase {
  configure({bingTag, ...restConfig}, ...restArgs) {
    super.configure({bingTag, ...restConfig}, ...restArgs);

    this.bingTag = bingTag;
  }

  getName() {
    return 'BingTracker';
  }

  get requiresTrackingConsent() {
    return true;
  }

  init(...params) {
    if (!this.canInitialize()) {
      return false;
    }

    if (!this.bingTag) {
      this.log('Bing disabled because no tag was specified.');
      this.disable();
    }

    window.BING_ID = this.bingTag;
    // eslint-disable-next-line
    (function (w, d, t, r, u) { let f; let n; let i; w[u] = w[u] || [], f = function () { const o = { ti: BING_ID }; o.q = w[u], w[u] = new UET(o), w[u].push('pageLoad'); }, n = d.createElement(t), n.src = r, n.async = 1, n.onload = n.onreadystatechange = function () { const s = this.readyState; s && s !== 'loaded' && s !== 'complete' || (f(), n.onload = n.onreadystatechange = null); }, i = d.getElementsByTagName(t)[0], i.parentNode.insertBefore(n, i); }).call(this, window, document, 'script', '//bat.bing.com/bat.js', 'uetq');

    super.init(...params);

    return true;
  }

  purchase(order, items, {addon} = {}) {
    if (!super.purchase(order, items, {addon})) {
      return false;
    }

    if (addon) {
      this.log('Bing conversion tracker will not fire for an add-on to an existing order', {order, addon});
      return false;
    }

    if (this.isRestrictedDataProcessingEnabled) {
      this.log('Bing conversion tracker will not fire in Restricted Data Processing mode');
      return false;
    }

    if (order && items) {
      /* eslint-disable camelcase */
      const purchaseEvent = {
        event_category: 'ecommerce',
        revenue_value: (order.subtotal + order.shipping).toFixed(2),
        currency: 'USD',
      };
      /* eslint-enable camelcase */

      window.uetq = window.uetq || [];
      window.uetq.push(
        'event',
        'purchase',
        purchaseEvent,
      );

      this.log('Bing Purchase Event Fired', purchaseEvent);
    } else {
      this.log("Order not processed, because it's null or missing items has a value of zero", order, items);
    }

    return true;
  }
}
